import React, { Component } from 'react';

import RaisedButton from 'material-ui/RaisedButton';
import SummariesList from '../SummariesList';
import './index.css';
import {history} from '../../../index';

class Main extends Component {

  componentDidMount() {
    setTimeout(() => {
      window.print()
    }, 1500);
  }

  render()
  {
    return (
      <div className="flex-container">
        <RaisedButton
         className="report-back-btn"
         style={{width: "100px"}}
         onClick={() => {
           history.goBack();
         }}
       label="Back" />

        <SummariesList
        key="SummariesList"
        summaries={this.props.location.state.summaries}
        incidents={this.props.location.state.incidents}
        definitionExpression={this.props.location.state.definitionExpression}
        extent={this.props.location.state.extent}
        screenshot={this.props.location.state.screenshot}
       />
       </div>
    )
  }
}

export default Main
